// removed by extract-text-webpack-plugin
module.exports = {"container":"ConfirmModal-container","message":"ConfirmModal-message"};